export const BANK_ID_LOGIN_BUTTON_TRACK_ID =
  "button-continue_with_bankid|Fortsett med BankId test";
export const SWITCH_TO_NO_BANK_ID_LOGIN_BUTTON_TRACK_ID =
  "button-continue_without_bankid|Fortsett uten BankId test";
export const CHANGE_YOUR_MIND_AND_LOGIN_WITH_BANK_ID_AFTER_ALL_BUTTON_TRACK_ID =
  "link-switch_to_bankid|BankId test";
export const NO_BANK_ID_LOGIN_BUTTON_TRACK_ID =
  "button-next_without_bankid|Neste test";
